import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { usePopup } from '../../context';
import { CreateMemoryGameSelectTypeTemplate } from '../../components/Templates';
import { QuestionAnswerLanguageSelectPopup } from '../../components/Popups/QuestionAnswerLanguageSelectPopup';
import { TtsLocale } from '../../models/Base';
import {
  getQuickCreateGameModeProps,
  QuickCreateGameMode,
} from '../../models/DraftStore';
import { useDraftStore } from '../../stores/DraftStore';
import { getUiLocale } from '../../utils/i18n';
import { TranslationLocale } from '../../i18n';

const CreateMemoryGameSelectTypeScreen: React.FC = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { showPopup, hidePopup } = usePopup();

  const managedClassroomId = useDraftStore((store) =>
    store.getManagedClassroomId(),
  );

  useEffect(() => {
    if (!managedClassroomId) {
      navigate('/home');
    }
  }, [managedClassroomId, navigate]);

  useEffect(() => {
    useDraftStore
      .getState()
      .setLocale(getUiLocale(i18n.language as TranslationLocale));
  }, [i18n.language]);

  const locale = useDraftStore((store) => store.getLocale());

  // const onGuideClick = useCallback(() => {
  //   window.open('https://joyajoy.com/pages/smart-parents-program', '_blank');
  // }, []);

  const onClickOK = useCallback(() => {
    hidePopup();
    navigate('/create/memory-game/input-content', { replace: true });
  }, [hidePopup, navigate]);

  const onSelectLanguage = useCallback(
    (language: TtsLocale) => {
      useDraftStore.getState().setLocale(language);
      hidePopup();
      navigate('/create/memory-game/input-content', { replace: true });
    },
    [hidePopup, navigate],
  );

  const onClickGameType = useCallback(
    (gameMode: QuickCreateGameMode) => {
      useDraftStore.getState().setGameMode(gameMode);
      const languageLists = getQuickCreateGameModeProps(gameMode).languageList;
      let defaultEnglish = false;
      if (languageLists && !languageLists.includes(locale)) {
        useDraftStore.getState().setLocale(TtsLocale.US);
        defaultEnglish = true;
      }
      showPopup(
        <QuestionAnswerLanguageSelectPopup
          languageList={getQuickCreateGameModeProps(gameMode).languageList}
          selectedLanguage={defaultEnglish ? TtsLocale.US : locale}
          onClickOK={onClickOK}
          onCancel={hidePopup}
          onSelectLanguage={onSelectLanguage}
        />,
      );
    },
    [hidePopup, locale, onClickOK, onSelectLanguage, showPopup],
  );

  return (
    <CreateMemoryGameSelectTypeTemplate
      // onGuideClick={onGuideClick}
      onQuickMemoryClick={() =>
        onClickGameType(QuickCreateGameMode.QuickMemory)
      }
      onSpellingClick={() => onClickGameType(QuickCreateGameMode.Spelling)}
    />
  );
};
export default CreateMemoryGameSelectTypeScreen;
